import React, { useEffect, useState } from "react";
import moment from 'moment';

import { Button, CircularProgress, Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Nav } from "../components/Interface";
import { Table } from '../components/Global';
import { interactiveTypes } from '../config/allInteractives'
import { MuiRouterLink, OutlinedFab } from "../components/CustomMui";
import api from "../utils/api";

/**
 * 
 * @todo
 * 
 * Move Table container styles to table? (may not be possible due to "no results" behavior?)
 * 
 */

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    backgroundColor: theme.palette.neutral.light2,
    padding: '32px 30px',
    overflow: 'auto',
    width: '100%',
    boxSizing: "border-box",
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 75px)',
    '& .MuiTextField-root': {
      marginTop: 0,
      marginRight: 0,
    },
    '& .MuiToolbar-root': {
      minHeight: 0,
      padding: '0 2px 0 7px',
    }
  },
  titleLinkWrapper: {
    position: 'relative',
    display: 'flex',
    '&::before': {
      content: '""',
      display: 'block',
      backgroundColor: theme.palette.neutral.light3,
      width: 'calc(100% + 24px)',
      height: '40px',
      borderRadius: '4px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      opacity: 0,
      transition: '.3s opacity'
    },
    '&:hover::before': {
      opacity: 1
    }
  },
  titleLink: {
    position: 'relative',
    '&:hover': {
      color: '#2E86DE'
    }
  },
  spinner: {
    margin: '0 auto',
    alignSelf: 'center',
  }
}));

const parseDate = (dateStr) => {
  const date = moment.utc(dateStr).format('MM/DD/YY')
  return date;
}

const getInteractiveLabel = (type) => {
  const intvs = interactiveTypes.filter(intv => {
    if (intv.name === type) {
      return true;
    }
    return false;
  })
  return intvs[0].label;
}

export function InteractiveManagement() {
  const classes = useStyles();
  
  const [data, setData] = useState([]);
  const [spinner, setSpinner] = useState(true)

  useEffect(() => {
    document.title = "PAVILION Interactive Builder";
  }, []);

  const getInteractives = () => {
    api.getInteractives()
      .then(res => {
        console.log(res.data)
        setData(res.data);
        setSpinner(false)
      })
  }

  useEffect(() => {
    getInteractives()
  }, [])

  const releaseLock = (lockUuid) => {
    api.unlockIntv(lockUuid)
      .finally(() => {
        getInteractives();
      })
  }

  const columns = [
    { title: 'Type', field: 'type',
      render: rowData => <Typography noWrap={true}>{getInteractiveLabel(rowData.type)}</Typography>, 
      customFilterAndSearch: (searchTerm, rowData) => getInteractiveLabel(rowData.type).indexOf(searchTerm) !== -1,
      width: '140px',
    },
    { title: 'Title', field: 'title',
      render: rowData => <span className={classes.titleLinkWrapper}>
                          <Tooltip title={rowData.title} arrow interactive leaveDelay={20}>
                            <Typography noWrap={true} className={classes.titleLink}><MuiRouterLink to={`/${rowData.type}/${rowData.id}`}>{rowData.title}</MuiRouterLink></Typography>
                          </Tooltip>
                        </span>
    },
    { title: 'Creator', field: 'creator',
      render: rowData => <Typography noWrap={true}>{rowData.creator}</Typography>, 
      width: '180px',
    },
    {
      title: 'Last Edited',
      field: 'lastEdited',
      type: 'date',
      render: rowData => <Typography noWrap={true}>{parseDate(rowData.lastEdited)}</Typography>,
      customFilterAndSearch: (searchTerm, rowData) => parseDate(rowData.lastEdited).indexOf(searchTerm) !== -1,
      defaultSort: 'desc',
      width: '110px',
    },
    { title: 'Created', field: 'created', type: 'date',
      render: rowData => <Typography noWrap={true}>{parseDate(rowData.created)}</Typography>, 
      customFilterAndSearch: (searchTerm, rowData) => parseDate(rowData.lastEdited).indexOf(searchTerm) !== -1,
      width: '110px',
    },
    {
      title: 'Locked By',
      field: 'lockOwner',
      render: rowData => <Typography noWrap={true}>{rowData.lockOwner ? rowData.lockOwner : 'N/A'}</Typography>,
      width: '180px', 
    },
    {
      title: '',
      field: 'lockUuid',
      render: rowData => {
        if (rowData.lockOwner) {
          return <Button onClick={() => releaseLock(rowData.lockUuid)} variant="text"><i className="fas fa-lock"></i></Button>
        } else {
          return <i className="fas fa-lock-open"></i>
        }
      },
      width: '50px', 
    },
    { 
      title: '', 
      field: 'link',  
      render: rowData => <OutlinedFab component={MuiRouterLink} to={`/${rowData.type}/${rowData.id}`} underline="none"><i className="fas fa-arrow-right"></i></OutlinedFab>,
      width: '50px',
      sorting: false
    },
   
  ];


  return (
    <>

      <Nav />

      <div className={classes.tableContainer}>

        { spinner 
          ? <CircularProgress className={classes.spinner} size={70} /> 
          : <Table data={data} columns={columns} />
        }

      </div>
      
    </>
  );
}
